import { useEffect, useState } from "react";
import { opsAPI, timeAgo, PRIORITY_STYLE } from "./opsApi";
import { AtSign } from "lucide-react";

export default function OpsMentions() {
  const [rows, setRows] = useState([]);
  useEffect(() => { opsAPI.mentions().then(setRows); }, []);
  return (
    <div className="space-y-4" data-testid="ops-mentions">
      <div className="text-[13px] text-slate-500">
        Notifications where you were explicitly @-mentioned. High-priority by default.
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {rows.length === 0
          ? <div className="p-12 text-center">
              <AtSign className="w-12 h-12 mx-auto text-slate-300 mb-2"/>
              <div className="text-[13px] text-slate-500">You haven&apos;t been mentioned yet.</div>
            </div>
          : <div className="divide-y divide-slate-100">
              {rows.map(n => (
                <div key={n.id} data-testid={`ops-mention-${n.id}`}
                     className={`px-4 py-3 ${n.state === "unread" ? "bg-sky-50/40" : ""}`}>
                  <div className="flex items-center gap-2">
                    <AtSign className="w-3.5 h-3.5 text-hocp-navy"/>
                    <span className={`px-2 py-0.5 rounded-md text-[10.5px] font-medium capitalize ${PRIORITY_STYLE[n.priority]}`}>{n.priority}</span>
                    <span className="mono text-[11px] text-slate-400">{timeAgo(n.created_at)}</span>
                  </div>
                  <div className="text-[13px] font-medium text-hocp-navy mt-1">{n.title}</div>
                  {n.description && <div className="text-[12px] text-slate-500 mt-0.5">{n.description}</div>}
                </div>
              ))}
            </div>}
      </div>
    </div>
  );
}
